export default "__VITE_ASSET__D85thDyf__"